export default __webpack_public_path__ + "static/media/close.b483fa61.svg";